import { Search } from "lucide-react";

const ShopHero = ({ search, setSearch }) => {
  return (
    <section className="bg-white border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <p className="text-green-600 font-medium">Home / Shop</p>

        <h1 className="mt-4 text-4xl md:text-5xl font-bold text-gray-900">
          Healthcare Equipment
        </h1>

        <p className="mt-4 text-gray-600 max-w-2xl">
          Browse our complete range of trusted healthcare equipment for
          hospitals, clinics, healthcare facilities, and home care.
        </p>

        <div className="mt-8 relative max-w-xl">
          <Search
            size={20}
            className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400"
          />

          <input
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            type="text"
            placeholder="Search products..."
            className="
  w-full
  pl-12
  pr-4
  py-4
  rounded-xl
  border
  border-gray-300
  focus:outline-none
  focus:ring-2
  focus:ring-green-500
  "
          />
        </div>
      </div>
    </section>
  );
};

export default ShopHero;
